/**
 * @generated SignedSource<<0aedb0e1cf8ba685e3d778da7251a785>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type KPIAnalyticsQuery$variables = {
  id: string;
};
export type KPIAnalyticsQuery$data = {
  readonly kpi: {
    readonly activeSections: ReadonlyArray<{
      readonly assignedTeam: {
        readonly id: string;
      } | null;
      readonly id: string;
    }>;
    readonly id: string;
    readonly title: string;
    readonly " $fragmentSpreads": FragmentRefs<"KPIAnalyticsSectionSelector_KPI" | "KPIPerWeekdayAnalytics" | "KPIStoreAnalytics_KPI" | "KPIWeeklyHighlightAnalytics">;
  } | null;
};
export type KPIAnalyticsQuery = {
  response: KPIAnalyticsQuery$data;
  variables: KPIAnalyticsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "RoutineSection",
  "kind": "LinkedField",
  "name": "section",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "assignedTeam",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v6/*: any*/),
        (v5/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "KPIAnalyticsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "KPI",
        "kind": "LinkedField",
        "name": "kpi",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RoutineSection",
            "kind": "LinkedField",
            "name": "activeSections",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "assignedTeam",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "KPIAnalyticsSectionSelector_KPI"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "KPIStoreAnalytics_KPI"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "KPIPerWeekdayAnalytics"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "KPIWeeklyHighlightAnalytics"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "KPIAnalyticsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "KPI",
        "kind": "LinkedField",
        "name": "kpi",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RoutineSection",
            "kind": "LinkedField",
            "name": "activeSections",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "assignedTeam",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "KPISectionAggregate",
            "kind": "LinkedField",
            "name": "sectionAggregates",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "KPIAggregateResult",
                "kind": "LinkedField",
                "name": "results",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "date",
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduledDays",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "KPISectionWeekdayAggregate",
            "kind": "LinkedField",
            "name": "weekdaySectionAggregates",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "KPIWeekdayAggregateResult",
                "kind": "LinkedField",
                "name": "results",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "weekday",
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "24f191126f7312622faa9b4e8e440fc6",
    "id": null,
    "metadata": {},
    "name": "KPIAnalyticsQuery",
    "operationKind": "query",
    "text": "query KPIAnalyticsQuery(\n  $id: ID!\n) {\n  kpi(id: $id) {\n    id\n    title\n    activeSections {\n      id\n      assignedTeam {\n        id\n      }\n    }\n    ...KPIAnalyticsSectionSelector_KPI\n    ...KPIStoreAnalytics_KPI\n    ...KPIPerWeekdayAnalytics\n    ...KPIWeeklyHighlightAnalytics\n  }\n}\n\nfragment KPIAnalyticsSectionSelector_KPI on KPI {\n  activeSections {\n    id\n    title\n    assignedTeam {\n      id\n      icon\n      name\n      color\n    }\n  }\n}\n\nfragment KPIPerWeekdayAnalytics on KPI {\n  id\n  title\n  icon\n  unit\n  scheduledDays\n  weekdaySectionAggregates {\n    section {\n      id\n      title\n      assignedTeam {\n        icon\n        color\n        name\n        id\n      }\n    }\n    results {\n      weekday\n      value\n    }\n  }\n}\n\nfragment KPIStoreAnalytics_KPI on KPI {\n  id\n  title\n  unit\n  sectionAggregates {\n    section {\n      id\n      title\n      assignedTeam {\n        icon\n        color\n        name\n        id\n      }\n    }\n    results {\n      date\n      value\n    }\n  }\n}\n\nfragment KPIWeeklyHighlightAnalytics on KPI {\n  id\n  title\n  icon\n  unit\n  team {\n    color\n    id\n  }\n  sectionAggregates {\n    section {\n      id\n      title\n      assignedTeam {\n        icon\n        color\n        name\n        id\n      }\n    }\n    results {\n      date\n      value\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8ba952d18fba1f104c23cc07eba264ae";

export default node;
